// "No recargues ahora": la app se recarga sola al detectar una versión nueva
// (main.jsx). Si eso pasa mientras se graba o se sube un vídeo, se pierde todo
// — visto 2026-10-18: un despliegue recargó la página a mitad de subir un vídeo
// de 190 MB. Las pantallas marcan aquí cuándo están ocupadas y la recarga
// espera a que terminen.
const reasons = new Set()

export function setBusy(reason, on) {
  if (on) reasons.add(reason)
  else reasons.delete(reason)
}

export function isBusy() {
  return reasons.size > 0
}
